'use strict';

import { listenDOMEvent } from '@jspartials/dom-api-utils';
import { getAjaxUrlWithParams } from '@jspartials/filter-utils';
import { gtmLaunchApplyFilter } from '@jspartials/gtm-utils';

// Selectors
const selector = {
  wrapper: {
    filterCollaboration: 'refinement-hk_collaboration'
  },
  filterSelect: '.js-select-filters'
};

// Variables
const customEventNameForAjaxRequestToSearch = 'sendAjaxRequestToSearch';

// Functions

function getParams(url) {
  var vars = {};

  if (url.indexOf('?') === -1) url = '?' + url;

  var parts = url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    vars[key] = value;
  });

  return vars;
}

function editCollectionParam(optionUrl, optionValue) {
  var vars = {};
  var index = -1;

  if (
    typeof optionUrl === 'undefined' ||
    optionUrl === null ||
    optionUrl === ''
  ) {
    optionUrl = window.location.href;
  }

  vars = getParams(optionUrl);

  for (const key in vars) {
    if (vars[key] === 'hk_collaboration') {
      index = key.substring(key.length - 1, key.length);
      break;
    }
  }

  if (index !== -1) {
    vars['prefv' + index] = optionValue;

    if (
      typeof optionValue === 'undefined' ||
      optionValue === null ||
      optionValue === ''
    ) {
      for (var i = index; i < vars.length; i++) {
        if (vars['prefv' + (i + 1)]) {
          vars['prefv' + index] = vars['prefv' + (index + 1)];
        } else {
          delete vars['prefv' + (i + 1)];
          delete vars['prefn' + (i + 1)];
        }
      }
    }
  }

  optionUrl = $.param(vars);

  return optionUrl;
}

/**
 * Update collaboration select
 * @returns {void}
 */
function updateCollaborationSelect() {
  const filterCollaboration =
    document.getElementById(selector.wrapper.filterCollaboration) || null;

  if (filterCollaboration) {
    const selectsFilter =
      document.querySelectorAll(selector.filterSelect) || [];
    const selectsCollaboration =
      filterCollaboration.getElementsByTagName('select') || [];
    const selectCollaboration = selectsCollaboration
      ? selectsCollaboration[0]
      : null;
    const filterId = selectCollaboration ? selectCollaboration.id : '';

    for (var i = 0; i < selectsFilter.length; i++) {
      let options = selectsFilter[i].options;

      for (var j = 0; j < options.length; j++) {
        let params = options[j].getAttribute('data-params');
        let value = options[j].value;

        options[j].setAttribute(
          'data-params',
          editCollectionParam(params, value)
        );
      }
    }

    if (selectCollaboration) {
      listenDOMEvent(selectCollaboration, 'change', function (event) {
        const optionSelectedForCollaboration =
          event.target.options[event.target.selectedIndex];
        const filterValueParams = optionSelectedForCollaboration
          ? optionSelectedForCollaboration.getAttribute('data-params')
          : '';
        const ajaxUrl = getAjaxUrlWithParams(filterValueParams);
        const filterValue =
          optionSelectedForCollaboration?.dataset?.presentationId;

        gtmLaunchApplyFilter(filterId, filterValue);

        document.dispatchEvent(
          new CustomEvent(customEventNameForAjaxRequestToSearch, {
            detail: {
              url: ajaxUrl
            }
          })
        );
      });
    }
  }
}

export { updateCollaborationSelect };
